import { useDispatch } from 'react-redux';

import axiosInstance from './axios-instance';
import { ApiEndPoints } from '../api-end-points';
import { AuthState, logout } from '../../slices/auth/login/reducer';
import { AppDispatch } from '../../slices/store';


export function setupAxiosIntercepters(
  authStore: AuthState,
) {
  const token = authStore.token; //ApiEndPoints.token;//localStorageService.getAccessToken()
  const sessionToken = authStore.sessionToken;
  //  const type = authStore.type;

  const _axiosInstance = axiosInstance;
  const dispatch: AppDispatch = useDispatch();
  _axiosInstance.interceptors.request.clear();
  // Add a request interceptor
  _axiosInstance.interceptors.request.use(
    (config) => {


      //config.data = _body;
      // console.log( config.data)
      // config.headers['Content-Type'] = 'application/json';
      let _path = (config.url ?? "").replace(config.baseURL ?? "", '')
      if (_path != ApiEndPoints.user_signIn_OTP) {
        config.headers['Authorization'] = token;
      } else {
        config.headers['SessionToken'] = sessionToken;
      }
      return config;
    },
    (error) => {
      Promise.reject(error);
    },
  );
  _axiosInstance.interceptors.response.clear();
  _axiosInstance.interceptors.response.use(
    (response) => {
      /*if (
       isLoginRelatedApi(response?.data?.method) &&
       (response.data?.result?.token ?? '') != ''
     ) {
         dispatch( setToken(response.data?.result?.token ?? '')); 
     } */
      /* if (islogout(response?.data?.method)) {
        dispatch(logout());
      } */
      return response;
    },
    function (error) {
      //const originalRequest = error.config
      //better change api to return 401
      let _path = (error.request.responseURL ?? "").replace(error.config.baseURL ?? "", '')
      if (
        error.response.status === 401) {
        if (!isLoginRelatedApi(_path)
        ) {
          dispatch(logout());
        }
        return Promise.reject(error);
      }

      return Promise.reject(error);
    },
  );

  function isLoginRelatedApi(method: string): boolean {
    return (method == ApiEndPoints.user_signIn_OTP || method == ApiEndPoints.user_switch_tenant);
  }


  /* function islogout(method: string): boolean {
    return method == ApiEndPoints.a;
  }  */
}
